import { Box, Grid } from '@material-ui/core'
import { Skeleton as MuiSkeleton } from '@material-ui/lab'

const skeletonLength = Array.from({ length: 6 })

export function Skeleton() {
  return (
    <>
      {skeletonLength.map((_, i) => (
        <Grid key={i} item xs={12} md={6} role='progressbar'>
          <Box height='18rem' minWidth='100%'>
            <MuiSkeleton
              animation='wave'
              width='100%'
              height='100%'
              variant='text'
              style={{ transform: 'initial' }}
            />
          </Box>
        </Grid>
      ))}
    </>
  )
}
